import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormFieldHelpers as Form } from '../../../../../../helpers/index';

class ThreadPostForm extends Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
    };
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {

    const { handleSubmit, quote } = this.props;
    const { width } = this.state;
    const isMobile = width <= 500;

    return (
      <div className="brand-background-color write-post">
        <h3 className="h3">Reply</h3>
        <form onSubmit={handleSubmit}>
          {isMobile ? <Field name="content" placeholder="Type your reply here..." component={Form.textAreaField}>
          </Field> : <Field name="content" placeholder="Type your reply here..." component={Form.autoTextAreaField}></Field>}
          <input className="btn btn-primary" type="submit" value="Post Reply" />
        </form>
      </div>
    );
  };
}

ThreadPostForm.propTypes = {
  handleSubmit: PropTypes.func
}

ThreadPostForm = reduxForm({ form: 'discussion_reply' })(ThreadPostForm);

export default ThreadPostForm;



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/ThreadPostForm.js